const servers = {
  TEST:{
    apiUri: "http://34.205.94.80:553/api",
    apiDomain: "34.205.94.80:553"
  },
  DEV:{
    apiUri: "https://ivemsaapidevv.azurewebsites.net/api",
    apiDomain: "ivemsaapidevv.azurewebsites.net"
  },
  PROD:{
    apiUri: "http://34.205.94.80:8090/api",
    apiDomain: "http://34.205.94.80:8090/"
  },
  DEMO:{
    apiUri: "http://webaccessdev.ddns.net:92/api",
    apiDomain: "http://localhost:86/api",
  }
}

export const environment = {
  firebase: {
    projectId: 'ivemsa-b0445',
    appId: '1:1080057654489:web:f11cf525875209345ae2c8',
    storageBucket: 'ivemsa-b0445.appspot.com',
    apiKey: 'AIzaSyAAQ6NEqZwK1WXvD1wuyRtdCil38pYrK3E',
    authDomain: 'ivemsa-b0445.firebaseapp.com',
    messagingSenderId: '1080057654489',
    measurementId: 'G-Z74GK4GXDN',
  },
  vapidKey: "BI-1W_dFzMJH3SS5P401nt2nChXxCNJHSd30kVIvZrxC_ozExTWbrXv1Jo62MZ-fFY6jVSVe7zlEvOFa-MLdFG8",
    production: true,
    apiUri: servers.PROD.apiUri, //-- CHANGE SERVER HERE
    apiDomain: servers.PROD.apiDomain
};
